import {useSearchParams} from 'react-router-dom';
import {Transitioner} from 'components';

import BillingHeaders from './Billing.Headers';
import BillingTableInvoice from './Billing.Table.Invoice';
import ModalBillingSuccess from './Modal.Billing.Success';

interface IBillingMineProps {}

const BillingMine = ({}: IBillingMineProps) => {
  const [searchParams] = useSearchParams();
  const success = searchParams.get('success') === 'true';
  const sessionId = searchParams.get('session_id') ?? '';
  return (
    <>
      <Transitioner>
        <div className="flex items-center justify-between">
          <div className="sm:flex-auto">
            <h1 className="font-medium text-lg dark:text-white">Billing and Invoices</h1>
            <p className="mt-2 text-sm text-gray-700 dark:text-darkText hidden sm:block">
              Configure subscription plan, payment cards and download invoices.
            </p>
          </div>
        </div>
        <Transitioner delay={0.1}>
          <BillingHeaders />
        </Transitioner>
        <Transitioner delay={0.2}>
          <BillingTableInvoice />
        </Transitioner>
      </Transitioner>
      {success && <ModalBillingSuccess sessionId={sessionId} />}
    </>
  );
};

export default BillingMine;
